import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { NotifierService } from 'angular-notifier';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-termandcond',
  templateUrl: './termandcond.component.html',
  styleUrls: ['./termandcond.component.scss']
})
export class TermandcondComponent implements OnInit {
  public representLine:String = "";

  constructor(
    public loginService:LoginService,
    public notifier:NotifierService,
    public sidePanelService:SidePanelService,
    public LoginService:LoginService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.LoginService.getTermAndCond().subscribe((data) =>{
      if(!data.status){
        setTimeout(() => {
          this.sidePanelService.afterLoginNavigate();
        })
      }else{
        this.loginService.termandCondType = data.type || '';
      }
    })
    if(localStorage.getItem('user_login_email')){
      this.representLine = localStorage.getItem('user_login_email');
    }
  }

  acceptTnc(){
    this.loginService.acceptTnc('accept',this.loginService.termandCondType).subscribe((data) =>{
      if(data.status){
        setTimeout(() => {
          const {redirect} = window.history.state;
          if(redirect && !redirect.includes('login')) {
            this.sidePanelService.afterLoginNavigate();
          }else{
            this.router.navigate(['/home-dashboard']);
          }
          
        })
      }else{
        this.notifier.notify('error','Something went wrong!');
      }
    })

  }

}
